import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  // Don't throw: a missing key must not take down the whole storefront.
  // The shop falls back to local product data and admin shows a setup notice.
  console.error(
    'Missing Supabase environment variables (REACT_APP_SUPABASE_URL / ' +
      'REACT_APP_SUPABASE_ANON_KEY). Running in offline mode.'
  );
}

// Placeholder credentials keep createClient valid so every call returns a
// normal { data, error } rejection instead of crashing at import time.
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-anon-key'
);

// Test connection
export const testConnection = async () => {
  try {
    const { error } = await supabase.from('products').select('count');

    if (error) {
      console.error('❌ Supabase connection failed:', error);
      return false;
    }

    console.log('✅ Supabase connected successfully!');
    return true;
  } catch (err) {
    console.error('❌ Supabase connection error:', err);
    return false;
  }
};
